export default __webpack_public_path__ + "static/media/1993.ad83cce8.png";